/* tslint:disable */
/* eslint-disable */
/**
 * Risks API
 * API for managing risks.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DemandeValidationDto } from './DemandeValidationDto';
import {
    DemandeValidationDtoFromJSON,
    DemandeValidationDtoFromJSONTyped,
    DemandeValidationDtoToJSON,
    DemandeValidationDtoToJSONTyped,
} from './DemandeValidationDto';

/**
 * Validation state of a quote: how the validation applies, the latest request and what it allows or blocks in the contractualisation.
 * @export
 * @interface EtatValidationDevis
 */
export interface EtatValidationDevis {
    /**
     * How the validation applies to the quote (tunnel setting and broker habilitation).
     * - Absente: the tunnel does not require any validation
     * - Optionnelle: the broker may ask for a validation but can go on without it
     * - Obligatoire: SEPA and signature are blocked until a validation is granted
     * 
     * @type {string}
     * @memberof EtatValidationDevis
     */
    mode: EtatValidationDevisModeEnum;
    /**
     * The validation applies but the tunnel has no main validator yet.
     * @type {boolean}
     * @memberof EtatValidationDevis
     */
    configurationIncomplete: boolean;
    /**
     * Latest request of the quote, null when none was ever sent.
     * @type {DemandeValidationDto}
     * @memberof EtatValidationDevis
     */
    derniereDemande?: DemandeValidationDto | null;
    /**
     * 
     * @type {boolean}
     * @memberof EtatValidationDevis
     */
    peutDemander: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EtatValidationDevis
     */
    peutAnnuler: boolean;
    /**
     * SEPA mandate and contract signature are blocked by the validation.
     * @type {boolean}
     * @memberof EtatValidationDevis
     */
    bloqueContractualisation: boolean;
    /**
     * Disabled reason code explaining the block (VALIDATION_REQUIRED, VALIDATION_PENDING, VALIDATION_REFUSED, VALIDATION_CONFIG_INCOMPLETE), null when not blocked.
     * @type {string}
     * @memberof EtatValidationDevis
     */
    raisonBlocage?: string | null;
}


/**
 * @export
 */
export const EtatValidationDevisModeEnum = {
    Absente: 'Absente',
    Optionnelle: 'Optionnelle',
    Obligatoire: 'Obligatoire'
} as const;
export type EtatValidationDevisModeEnum = typeof EtatValidationDevisModeEnum[keyof typeof EtatValidationDevisModeEnum];


/**
 * Check if a given object implements the EtatValidationDevis interface.
 */
export function instanceOfEtatValidationDevis(value: object): value is EtatValidationDevis {
    if (!('mode' in value) || value['mode'] === undefined) return false;
    if (!('configurationIncomplete' in value) || value['configurationIncomplete'] === undefined) return false;
    if (!('peutDemander' in value) || value['peutDemander'] === undefined) return false;
    if (!('peutAnnuler' in value) || value['peutAnnuler'] === undefined) return false;
    if (!('bloqueContractualisation' in value) || value['bloqueContractualisation'] === undefined) return false;
    return true;
}

export function EtatValidationDevisFromJSON(json: any): EtatValidationDevis {
    return EtatValidationDevisFromJSONTyped(json, false);
}

export function EtatValidationDevisFromJSONTyped(json: any, ignoreDiscriminator: boolean): EtatValidationDevis {
    if (json == null) {
        return json;
    }
    return {
        
        'mode': json['mode'],
        'configurationIncomplete': json['configurationIncomplete'],
        'derniereDemande': json['derniereDemande'] == null ? undefined : DemandeValidationDtoFromJSON(json['derniereDemande']),
        'peutDemander': json['peutDemander'],
        'peutAnnuler': json['peutAnnuler'],
        'bloqueContractualisation': json['bloqueContractualisation'],
        'raisonBlocage': json['raisonBlocage'] == null ? undefined : json['raisonBlocage'],
    };
}

export function EtatValidationDevisToJSON(json: any): EtatValidationDevis {
    return EtatValidationDevisToJSONTyped(json, false);
}

export function EtatValidationDevisToJSONTyped(value?: EtatValidationDevis | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'mode': value['mode'],
        'configurationIncomplete': value['configurationIncomplete'],
        'derniereDemande': DemandeValidationDtoToJSON(value['derniereDemande']),
        'peutDemander': value['peutDemander'],
        'peutAnnuler': value['peutAnnuler'],
        'bloqueContractualisation': value['bloqueContractualisation'],
        'raisonBlocage': value['raisonBlocage'],
    };
}

